import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const commerceExterieurData = [
  {
  title: "Rapport annuel sur les statistiques du Commerce Extérieur des Marchandises au Burundi, édition 2024",
  description: "Le rapport annuel 2024 du commerce extérieur burundais met en lumière les chiffres clés des échanges de biens : un déficit commercial record de 2 523,2 milliards BIF, des importations représentant 86% du total des échanges, et des exportations dominées par le café, le thé, et les fruits et légumes (environ 29,6% du total). La période a été marquée par une inflation de 36,5% et une dépréciation du franc burundais de 12,1% par rapport au dollar américain, impactant la compétitivité des exportations et le coût des importations.",
  principalLink: "/documents/Annuaires/Rapport_Annuel_Statistiques_Commerce_Exterieur_edition_2024.pdf",
  date: "2024-12-30",
  publicationDate: "2025-12-30",
  image: 'assets/annuaires/ace.png',
},

   {
    title: "Rapport annuel de 2023 sur le Commerce Extérieur de Marchandises",
    principalLink: "/documents/Annuaires/Rapport_annuel_statistiques_commerce_extérieur_2023.pdf",
    image: 'assets/annuaires/ace.png',
    description: "Malgré une légère amélioration du taux de couverture, le déficit commercial continue de se creuser pour atteindre un niveau record de 2 523,2 milliards en 2023, les importations maintennant leur domination structurelle sur les exportations",
    date: "2024-12-30",
    publicationDate: "2024-12-30",
  },
   {
    title: "Rapport annuel de 2022 sur le Commerce Extérieur de Marchandises",
    principalLink: "/documents/Annuaires/Rapport_annuel_2022_statistiques_commerce_extérieur.pdf",
    image: 'assets/annuaires/ace.png',
    description: "Malgré une croissance encourageante des exportations (+30,8%), le déficit commercial atteint un niveau record de 2 141 milliards en 2022, les importations, qui représentent 85,8% des échanges, continuant de creuser l'écart.",
    date: "2023-09-30",
    publicationDate: "2023-09-30",
  },
   {
    title: "Rapport annuel de 2021 sur le Commerce Extérieur de Marchandises",
    principalLink: "/documents/Annuaires/Rapport_annuel_2021_statistiques_commerce_xtérieur.pdf",
    image: 'assets/annuaires/ace.png',
    description: "Malgré une hausse globale des échanges commerciaux, le déficit de la balance commerciale s'est creusé de 19% en 2021 pour atteindre 1 702 milliards, les importations (86,2% du total) progressant bien plus vite que les exportations, ce qui a fait chuter le taux de couverture à 16%, son plus bas niveau depuis 2018.",
    date: "2022-12-30",
    publicationDate: "2022-12-30",
  },
   {
    title: "Rapport annuel de 2020 sur le Commerce Extérieur de Marchandises",
    principalLink: "/documents/Annuaires/Rapport_annuel_2020_statistiques_commerce_extérieur.pdf",
    image: 'assets/annuaires/ace.png',
    description: "Malgré des taux de croissance encourageants des exportations entre 2016 et 2019, le déficit commercial n'a cessé de se creuser pour atteindre 1 433,1 milliards en 2020, une année marquée par un recul des exportations de 7,4 % et un taux de couverture qui chute à 17,7 %, reflétant la fragilité structurelle de la balance commerciale.",
    date: "2021-09-30",
    publicationDate:"2021-09-30",
  },/*
   {
    title: "Rapport annuel de 2019 sur le Commerce Extérieur de Marchandises",
    principalLink: "/documents/Annuaires/Commerce-extérieur-2018.pdf",
    image: 'assets/annuaires/ace.png',
    description: "En 2018, le commerce extérieur du Burundi affiche un volume total de 1 736 milliards FBu (+20% vs 2015), avec un déficit important de 1 093 milliards FBu malgré une croissance des exportations à 321 milliards (+24% vs 2017). Le taux de couverture des importations par les exportations reste faible à 22,7%.",
    date: "2019-10-30",
    publicationDate: "2019-10-30",
  },*/
  {
    title: "Rapport annuel de 2018 sur le Commerce Extérieur de Marchandises",
    principalLink: "/documents/Annuaires/Commerce-extérieur-2018.pdf",
    image: 'assets/annuaires/ace.png',
    description: "En 2018, le commerce extérieur du Burundi affiche un volume total de 1 736 milliards FBu (+20% vs 2015), avec un déficit important de 1 093 milliards FBu malgré une croissance des exportations à 321 milliards (+24% vs 2017). Le taux de couverture des importations par les exportations reste faible à 22,7%.",
    date: "2019-10-30",
    publicationDate: "2019-10-30",
  },
];

function AnnuaireCommerceExterieur() {
  const [visibleCount, setVisibleCount] = useState(2);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredCommerce, setFilteredCommerce] = useState(commerceExterieurData);
  const navigate = useNavigate();

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredCommerce(commerceExterieurData);
    } else {
      const filtered = commerceExterieurData.filter((commerce) => {
        const commerceYear = new Date(commerce.date).getFullYear();
        return commerceYear === parseInt(year);
      });
      setFilteredCommerce(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />

        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Annuaire du Commerce Extérieur
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            L’annuaire statistique du commerce extérieur et de marchandises met en lumière l’évolution nominale des importations et des exportations du Burundi. Cette publication répond à l’une des missions de l’INSBU de fournir des statistiques sur l’économie nationale, particulièrement celles liées au commerce extérieur, à des institutions nationales et internationales, des acteurs politiques, des entreprises et des universités. Cette initiative s’inscrit dans le cadre de la stratégie nationale de développement et de dynamisation du secteur privé, ainsi que de la diversification économique pour améliorer le climat des affaires.
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionner par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionner par l'année de publication"
            >
              <MenuItem value="Tous">Toutes les statistiques</MenuItem>
              {[...new Set(commerceExterieurData.map((commerce) => new Date(commerce.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

      
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredCommerce.slice(0, visibleCount).map((commerce, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={commerce.principalLink}
                      target="_blank"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 120, m: 2 }}
                        image={commerce.image}
                        alt={commerce.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                        <a
                          href={commerce.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                          {<DownloadIcon />}{commerce.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {commerce.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(commerce.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredCommerce.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Statistiques
            </Button>
          )}
  <br />
  <br />
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
                 onClick={() => navigate('/annuaire')}
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page principale
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default AnnuaireCommerceExterieur;